const { CHECKER_EVENT_TYPES } = require("./checker.constants")

export const checkEventTypeExist = (data) => {
    Object.keys(CHECKER_EVENT_TYPES).includes(data);
}

export const CHECKER_BASE_URL = '/checker/';


export const fetchMleSectionData = (data, tabname) => {
    
    let resp = null;
    try {
        if (typeof data?.childCheckerResponseList === 'object') {
            data.childCheckerResponseList.map(makerCheckerResponse => {
                
                if (makerCheckerResponse && !resp) {
                    if (tabname === makerCheckerResponse.eventType.toLowerCase()) {
                        
                        
                        resp = JSON.parse(JSON.stringify(makerCheckerResponse));
                        
                        // return {...makerCheckerResponse};
                    }
                }
            });
        }
    } catch (e) {
        return null;
    }
    
    return resp;
};


export const getCheckerData = (data, tabname, addtionalData) => {
    
    let businessRequestedData = {};
    let draftData = {};
    if (typeof data?.childCheckerResponseList === 'object') {
        data.childCheckerResponseList.map((makerCheckerResponse) => {
            if (makerCheckerResponse) {
                    // if(makerCheckerResponse?.eventType){
                    //     console.log("yes it has eventType of : ", makerCheckerResponse.eventType);
                    // }
                    if(tabname===makerCheckerResponse.eventType.toLowerCase()){
                        businessRequestedData = JSON.parse(makerCheckerResponse.request);
                        
                        draftData = {...businessRequestedData};
                    }
                }
        });
    }
    
    
    
    if (draftData?.panDetails?.dob) {
        delete draftData.panDetails.dob;
    }


    return draftData;
}

export const isCheckerSectionDataExist = (checkerData, sectionType) => {
    try {
        
        const sectionData = fetchMleSectionData(checkerData, sectionType);
        return !!sectionData;
    } catch(e) {
        return false;
    }
}

export const isCheckerActionable = (checkerData, sectionType) => {
    try {
    
        const sectionData = fetchMleSectionData(checkerData, sectionType);
        
        return sectionData?.userActionStatus === 'PENDING';

    } 
    catch (e) {
        
        return false;
    }
    // return false;

}